import PropTypes from "prop-types";

const EditIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3339 4.57396L8.7471 12.1731C7.99152 12.9299 5.74887 13.2803 5.24785 12.7784C4.74684 12.2766 5.08872 10.0303 5.8443 9.27349L13.4392 1.66644C13.6265 1.46189 13.8532 1.29724 14.1058 1.18277C14.3582 1.06831 14.6314 1.00617 14.9087 1.00044C15.1856 0.994704 15.4612 1.04513 15.7184 1.14884C15.9756 1.25255 16.2089 1.4074 16.4048 1.60407C16.6004 1.80074 16.7545 2.03493 16.8574 2.29278C16.9602 2.55062 17.0098 2.82663 17.0034 3.10407C16.9967 3.38175 16.934 3.65489 16.8192 3.90772C16.7042 4.16031 16.5393 4.38709 16.3344 4.5742L16.3339 4.57396Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.15738 2.66223H4.18098C3.33736 2.66223 2.52834 2.99798 1.93165 3.5954C1.3352 4.19306 1 5.00339 1 5.84838V13.8139C1 14.6589 1.3352 15.4694 1.93165 16.0669C2.52834 16.6645 3.33736 17 4.18098 17H12.929C14.6866 17 15.3148 15.5662 15.3148 13.8139V9.83101"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const { string } = PropTypes;

EditIcon.propTypes = {
  className: string
};

export default EditIcon;
